/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import { ModalHeader } from 'reactstrap';
import Form from '../Form';
import useForm from '../../hooks/useForm';
import { viewLoading } from '../../utils/loading';
import EmployeeSignField from './EmployeeSignField';
import { isEmpty } from '../../utils/lodashExtend';
import { createSign } from '../../apis/employee/employee-sign';
import { cleanObj } from '../../utils/cleanObj';
import { dataURLtoFile, fileUpload } from '../../utils/file';


const EmployeeSignCreate = ({ open, setOpen, submit, isAvailable, reloadMyInfo }) => {
  const [formFields, setFormFields] = useState([]);
  const [signEmployeeOpen, setSignEmployeeOpen] = useState(false);


  const _submit = (form) => {
    viewLoading(true);
    const body = {
      ...cleanObj(form),
      available: !isAvailable
    };
    createSign(body).then(res => {
      submit();
      reset();
      setOpen(false);
      reloadMyInfo();
    }).finally(() => viewLoading(false));
  };


  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
    reset();
  };


  const validate = ({
    type,
    fileIdx
  }) => {
    let errors = {};
    if (type === "direct" && isEmpty(fileIdx)) errors.type = "서명을 작성해야 합니다.";
    if (type === "upload" && isEmpty(fileIdx)) errors.type = "파일첨부가 필요합니다.";

    return errors;
  };


  const {
    form,
    // setForm,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
  } = useForm(
    {
      type: "direct",
      fileIdx: "",
      signUri: "",
    },
    _submit,
    validate,
  );



  const submitSign = (sign) => {
    const file = dataURLtoFile(sign, "직접서명.png");
    fileUpload(file, true).then(res => {
      handleOnChange({ fileIdx: [res.fileIdx] });
    });
  };

  useEffect(() => {
    setFormFields([
      [
        {
          title: "타입",
          key: "type",
          type: "radio",
          required: true,
          options: {
            list: [{ label: "직접 서명", value: "direct" }, { label: "파일 첨부", value: "upload" }],
          },
        },
        {
          isHide: form.type !== "direct",
          type: "button",
          color: "gray-line",
          label: "서명하기",
          required: form.type === "direct",
          action: () => {
            setSignEmployeeOpen(true);
          },
          labelWidth: 0,
        },
      ],
      [
        {
          isHide: form.type !== "upload",
          title: "첨부파일",
          key: "fileIdx",
          type: "dropzone",
          isSingle: true,
          accept: "image/*",
          required: form.type === "upload",
        },
      ],
    ]);
  }, [form.type]);

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        <div className="additional-write">
          <ModalHeader>
            서명 추가
          </ModalHeader>
          <Form
            fields={formFields}
            form={form}
            onChange={handleOnChange}
            submit={handleSubmit}
            cancel={cancel}
            errors={errors}
          />
        </div>
      </Modal>

      {signEmployeeOpen && (
        <EmployeeSignField
          open={signEmployeeOpen}
          setOpen={setSignEmployeeOpen}
          submit={submitSign}
          uri={form.signUri}

        />
      )}
    </>
  );
};

export default EmployeeSignCreate;